export const ADMIN_LOGIN = `/admin/auth/token`;
export const SETTER_LOGIN = `/setter/auth/token`;
export const CHECKER_LOGIN = `/checker/auth/token`;
export const COUNSELLOR_LOGIN = `/counselor/auth/token`;
export const GET_PERMISSIONS = (type = "counselor") => type === "counselor" ? `/${type}/permissions` : `/${type}/auth/permissions`;
export const REVIEWER_LOGIN = `/reviewer/auth/token`;
